import { NgModule } from '@angular/core';

import { DraggableDirective } from './Draggable.AngularDirective';
import { DroppableDirective } from './Droppable.AngularDirective';

import './lib';

const declarations = [
	DraggableDirective,
	DroppableDirective
];

@NgModule({
	declarations,
	exports: declarations
})
export class DragAndDropAngularModule {}
